
import { useProjects } from './useProjects';

export function useDashboardProjects() {
  return useProjects();
}
